import { timeOptions, timezoneOptions } from '../../../helpers/SchedulingHelper';

import { WEEKLY_SCHEDULING_LABELS } from './labels';
import { InputType } from './WeeklyScheduling.types';

export const inputsList: InputType[] = [
	{
		id: 'scheduling-time-select',
		type: 'selectedTime',
		label: WEEKLY_SCHEDULING_LABELS.time,
		placeholder: WEEKLY_SCHEDULING_LABELS.time,
		options: timeOptions,
		isSearchable: true,
		isMultiple: false
	},
	{
		id: 'scheduling-timezone-select',
		type: 'selectedTimezone',
		label: WEEKLY_SCHEDULING_LABELS.timezone,
		placeholder: WEEKLY_SCHEDULING_LABELS.timezone,
		options: timezoneOptions,
		isSearchable: true,
		isMultiple: false
	}
];
